module.exports = __webpack_public_path__ + "js/2.95413f88.worker.js"